var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ReminderGrid', {
    key: _vm.key,
    on: {
      "forceUpdate": function ($event) {
        _vm.key++;
      }
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }